import React from "react";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

const Seo = ({ metaData = [], appSetting = {}, pageUrl = "" }) => {
  const router = useRouter();
  const { locale } = router;

  const metaTitle = metaData?.find((meta) => meta.name === "title");
  const description = metaData?.find((meta) => meta.name === "description");
  const { appName_EN, appName } = appSetting || {};

  return (
    <NextSeo
      title={metaTitle?.content}
      description={description?.content || ""}
      // canonical={pageUrl ? pageUrl : ""}
      openGraph={{
        title: metaTitle?.content,
        description: description?.content,
        type: "website",
        locale: locale,
        url: pageUrl ? pageUrl : "",
        images: [
          {
            url: `${process.env.NEXT_PUBLIC_API_URL}/${appSetting?.AppSetting?.appLogo}`,
            width: 800,
            height: 600,
            alt: metaTitle?.content,
          },
        ],
      }}
      twitter={{
        handle: `@${appSetting?.socials?.twitter?.split("https://x.com/")[1]}`,
        site: "https://x.com",
        cardType: "summary_large_image",
      }}
    />
  );
};

export default Seo;
